export default "__VITE_ASSET__CMw4eJQn__"